import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { MENU_PERMISSIONS } from '../context/permissions'
import './SideBar.css'

const menuItems = [
  { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
  {
    label: 'Customers',
    path: '/customers',
    icon: 'customers',
    permissions: MENU_PERMISSIONS.customers,
  },
  {
    label: 'Samples',
    path: '/samples',
    icon: 'samples',
    permissions: MENU_PERMISSIONS.samples,
  },
]

const salesItems = [
  {
    label: 'Orders',
    path: '/sales/orders',
    permissions: MENU_PERMISSIONS.orders,
  },
  {
    label: 'Payments',
    path: '/sales/payments',
    permissions: MENU_PERMISSIONS.payments,
  },
  {
    label: 'Debtors',
    path: '/sales/debtors',
    permissions: MENU_PERMISSIONS.debtors,
  },
  {
    label: 'Old Payments',
    path: '/sales/old-payments',
    permissions: MENU_PERMISSIONS.oldPayments,
  },
]

const adminItems = [
  {
    label: 'Authors',
    path: '/admin/authors',
    icon: 'authors',
    permissions: MENU_PERMISSIONS.authors,
  },
  {
    label: 'Books',
    path: '/admin/books',
    icon: 'books',
    permissions: MENU_PERMISSIONS.books,
    children: [
      {
        label: 'Published Books',
        path: '/admin/books/publish-books',
        icon: 'publish',
        permissions: MENU_PERMISSIONS.books,
      },
      {
        label: 'Exercise Books',
        path: '/admin/books/exercise-books',
        icon: 'exercise',
        permissions: MENU_PERMISSIONS.books,
      },
    ],
  },
  {
    label: 'Royalties',
    path: '/admin/royalties',
    icon: 'royalties',
    permissions: MENU_PERMISSIONS.royalties,
  },
  {
    label: 'Users',
    path: '/admin/users',
    icon: 'users',
    permissions: MENU_PERMISSIONS.users,
  },
  {
    label: 'Stores',
    path: '/admin/stores',
    icon: 'stores',
    permissions: MENU_PERMISSIONS.stores,
  },
  {
    label: 'Stock',
    path: '/admin/stock',
    icon: 'stock',
    permissions: MENU_PERMISSIONS.stock,
  },
  {
    label: 'Print Request',
    path: '/admin/print-request',
    icon: 'printRequest',
    permissions: MENU_PERMISSIONS.printRequests,
  },
  {
    label: 'Audit Log',
    path: '/admin/audit-log',
    icon: 'audit',
    permissions: MENU_PERMISSIONS.auditLog,
  },
  {
    label: 'Reports',
    path: '/admin/reports',
    icon: 'reports',
    children: [
      {
        label: 'Publishing',
        path: '/admin/reports/publishing',
        icon: 'publishing',
        permissions: MENU_PERMISSIONS.publishingReports,
      },
      {
        label: 'Accounting',
        path: '/admin/reports/accounting',
        icon: 'accounting',
        permissions: MENU_PERMISSIONS.accountingReports,
      },
      {
        label: 'Stores',
        path: '/admin/reports/stores',
        icon: 'stores',
        permissions: MENU_PERMISSIONS.storesReports,
      },
      {
        label: 'Manager Insights',
        path: '/admin/reports/insights',
        icon: 'reports',
        permissions: MENU_PERMISSIONS.managerInsights,
      },
    ],
  },
]

function Icon({ name }) {
  const paths = {
    dashboard: (
      <>
        <rect x='3' y='3' width='7' height='7' rx='1' />
        <rect x='14' y='3' width='7' height='7' rx='1' />
        <rect x='3' y='14' width='7' height='7' rx='1' />
        <rect x='14' y='14' width='7' height='7' rx='1' />
      </>
    ),
    customers: (
      <>
        <circle cx='9' cy='8' r='3' />
        <path d='M3.5 20a5.5 5.5 0 0 1 11 0M16 5.5a3 3 0 0 1 0 5.8M17 14.5a5.2 5.2 0 0 1 3.5 4.9' />
      </>
    ),
    samples: (
      <>
        <path d='M5 5h14v14H5zM8 9h8M8 13h5' />
        <path d='M8 3v2M16 3v2' />
      </>
    ),
    sales: (
      <>
        <path d='M4 6h16M4 12h16M4 18h16' />
        <circle cx='8' cy='6' r='1.5' />
        <circle cx='16' cy='12' r='1.5' />
        <circle cx='10' cy='18' r='1.5' />
      </>
    ),
    orders: (
      <>
        <path d='M5 4h14v16H5zM8 8h8M8 12h8M8 16h5' />
      </>
    ),
    payments: (
      <>
        <rect x='3' y='5' width='18' height='14' rx='2' />
        <path d='M3 10h18M7 15h3' />
      </>
    ),
    debtors: (
      <>
        <circle cx='12' cy='12' r='8.5' />
        <path d='M12 7v10M15 9.5c-.7-.8-1.7-1.2-3-1.2-1.6 0-2.7.8-2.7 2s1 1.8 2.7 2.2 2.7.9 2.7 2.1-1.1 2-2.7 2c-1.3 0-2.3-.4-3-1.2' />
      </>
    ),
    oldPayments: (
      <>
        <path d='M4 6h13a3 3 0 0 1 3 3v9M4 6l2-2M4 6l2 2M20 18H7a3 3 0 0 1-3-3V6M20 18l-2-2M20 18l-2 2' />
      </>
    ),
    publish: (
      <>
        <path d='M4 5h16v14H4zM8 9h8M8 13h5' />
      </>
    ),
    exercise: (
      <>
        <path d='M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3zM8 4v16M10 9h6M10 13h6' />
      </>
    ),
    authors: (
      <>
        <circle cx='9' cy='8' r='3' />
        <path d='M3.5 20a5.5 5.5 0 0 1 11 0M15 13l2 2 4-4' />
      </>
    ),
    books: (
      <>
        <path d='M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3zM8 4v16M10 9h6M10 13h6' />
      </>
    ),
    royalties: (
      <>
        <circle cx='12' cy='12' r='8.5' />
        <path d='M12 7v10M15 9.5c-.7-.8-1.7-1.2-3-1.2-1.6 0-2.7.8-2.7 2s1 1.8 2.7 2.2 2.7.9 2.7 2.1-1.1 2-2.7 2c-1.3 0-2.3-.4-3-1.2' />
      </>
    ),
    users: (
      <>
        <circle cx='9' cy='8' r='3' />
        <circle cx='17' cy='9' r='2.5' />
        <path d='M3.5 20a5.5 5.5 0 0 1 11 0M15 15a5 5 0 0 1 5.5 5' />
      </>
    ),
    stores: (
      <>
        <path d='M4 10h16v10H4zM3 10l2-5h14l2 5' />
        <path d='M8 10v10M16 10v10M3 10a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0' />
      </>
    ),
    stock: (
      <>
        <path d='m4 8 8-4 8 4-8 4zM4 8v8l8 4 8-4V8M12 12v8' />
        <path d='m8 6 8 4' />
      </>
    ),
    printRequest: (
      <>
        <path d='M6 9V4h12v5M6 17H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2' />
        <path d='M6 14h12v7H6zM17 12h1' />
      </>
    ),
    reports: (
      <>
        <path d='M5 20V10M12 20V4M19 20v-7' />
        <path d='M3 20h18' />
      </>
    ),
    publishing: (
      <>
        <path d='M4 5h16v14H4zM8 9h8M8 13h5' />
      </>
    ),
    accounting: (
      <>
        <path d='M4 4h16v16H4zM8 8h8M8 12h8M8 16h4' />
      </>
    ),
    audit: (
      <>
        <path d='M6 3h9l4 4v14H6zM15 3v4h4' />
        <path d='m9 14 2 2 4-4' />
      </>
    ),
  }

  return (
    <svg className='side-bar__icon' viewBox='0 0 24 24' aria-hidden='true'>
      {paths[name]}
    </svg>
  )
}

function Chevron({ open }) {
  return (
    <svg
      className={`side-bar__chevron ${open ? 'is-open' : ''}`}
      viewBox='0 0 24 24'
      aria-hidden='true'
    >
      <path d='m9 18 6-6-6-6' />
    </svg>
  )
}

function SideBar({ isMobileOpen = false, onNavigate }) {
  const { hasAnyPermission } = useAuth()
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [isSalesOpen, setIsSalesOpen] = useState(false)
  const [openSalesItem, setOpenSalesItem] = useState('')
  const [isAdminOpen, setIsAdminOpen] = useState(false)
  const [openAdminItem, setOpenAdminItem] = useState('')
  const visibleMenuItems = menuItems.filter(
    (item) => !item.permissions || hasAnyPermission(item.permissions),
  )
  const visibleSalesItems = salesItems.filter((item) =>
    hasAnyPermission(item.permissions),
  )
  const visibleAdminItems = adminItems
    .map((item) => ({
      ...item,
      children: item.children?.filter((child) =>
        hasAnyPermission(child.permissions),
      ),
    }))
    .filter(
      (item) =>
        (item.children ? item.children.length > 0 : true) &&
        hasAnyPermission(item.permissions || []),
    )

  const sidebarClassName = `side-bar ${isCollapsed ? 'is-collapsed' : ''} ${
    isMobileOpen ? 'is-mobile-open' : 'is-mobile-closed'
  }`

  return (
    <aside className={sidebarClassName}>
      <div className='side-bar__header'>
        <div className='side-bar__heading'>
          <span className='side-bar__title'>Menu</span>
          <span className='side-bar__subtitle'>Workspace</span>
        </div>
        <button
          className='side-bar__collapse'
          type='button'
          onClick={() => setIsCollapsed((collapsed) => !collapsed)}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <Chevron open={!isCollapsed} />
        </button>
      </div>

      <nav
        className='side-bar__nav'
        id='workspace-navigation'
        aria-label='Workspace navigation'
      >
        <ul className='side-bar__list'>
          {visibleMenuItems.map((item) => (
            <li key={item.label}>
              <NavLink
                className='side-bar__link'
                to={item.path}
                onClick={onNavigate}
                title={isCollapsed ? item.label : undefined}
              >
                <Icon name={item.icon} />
                <span className='side-bar__label'>{item.label}</span>
              </NavLink>
            </li>
          ))}
          {visibleSalesItems.length > 0 && (
            <li>
              <button
                className='side-bar__link side-bar__link--button'
                type='button'
                onClick={() => setIsSalesOpen((open) => !open)}
                aria-expanded={isSalesOpen}
                title={isCollapsed ? 'Sales' : undefined}
              >
                <Icon name='sales' />
                <span className='side-bar__label'>Sales</span>
                <Chevron open={isSalesOpen} />
              </button>
              {isSalesOpen && (!isCollapsed || isMobileOpen) && (
                <ul className='side-bar__nested-list'>
                  {visibleSalesItems.map((item) => {
                    const iconName =
                      item.label === 'Old Payments'
                        ? 'oldPayments'
                        : item.label.toLowerCase()
                    if (
                      item.label === 'Payments' ||
                      item.label === 'Debtors' ||
                      item.label === 'Old Payments'
                    ) {
                      return (
                        <li key={item.label}>
                          <NavLink
                            className='side-bar__link side-bar__link--nested'
                            to={item.path}
                            onClick={onNavigate}
                          >
                            <Icon name={iconName} />
                            <span className='side-bar__label'>
                              {item.label}
                            </span>
                          </NavLink>
                        </li>
                      )
                    }
                    const isOpen = openSalesItem === item.label
                    return (
                      <li key={item.label}>
                        <button
                          className='side-bar__link side-bar__link--nested side-bar__link--button'
                          type='button'
                          onClick={() =>
                            setOpenSalesItem(isOpen ? '' : item.label)
                          }
                          aria-expanded={isOpen}
                        >
                          <Icon name={iconName} />
                          <span className='side-bar__label'>{item.label}</span>
                          <Chevron open={isOpen} />
                        </button>
                        {isOpen && (
                          <ul className='side-bar__leaf-list'>
                            <li>
                              <NavLink
                                className='side-bar__link side-bar__link--leaf'
                                to={`${item.path}/publish-books`}
                                onClick={onNavigate}
                              >
                                <Icon name='publish' />
                                <span className='side-bar__label'>
                                  Published Books
                                </span>
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className='side-bar__link side-bar__link--leaf'
                                to={`${item.path}/exercise-books`}
                                onClick={onNavigate}
                              >
                                <Icon name='exercise' />
                                <span className='side-bar__label'>
                                  Exercise Books
                                </span>
                              </NavLink>
                            </li>
                          </ul>
                        )}
                      </li>
                    )
                  })}
                </ul>
              )}
            </li>
          )}
          {visibleAdminItems.length > 0 && (
            <li>
              <button
                className='side-bar__link side-bar__link--button'
                type='button'
                onClick={() => setIsAdminOpen((open) => !open)}
                aria-expanded={isAdminOpen}
                title={isCollapsed ? 'Admin' : undefined}
              >
                <Icon name='users' />
                <span className='side-bar__label'>Admin</span>
                <Chevron open={isAdminOpen} />
              </button>
              {isAdminOpen && (!isCollapsed || isMobileOpen) && (
                <ul className='side-bar__nested-list'>
                  {visibleAdminItems.map((item) => {
                    const isOpen = openAdminItem === item.label
                    return (
                      <li key={item.label}>
                        {item.children ? (
                          <button
                            className='side-bar__link side-bar__link--nested side-bar__link--button'
                            type='button'
                            onClick={() =>
                              setOpenAdminItem(isOpen ? '' : item.label)
                            }
                            aria-expanded={isOpen}
                          >
                            <Icon name={item.icon} />
                            <span className='side-bar__label'>
                              {item.label}
                            </span>
                            <Chevron open={isOpen} />
                          </button>
                        ) : (
                          <NavLink
                            className='side-bar__link side-bar__link--nested'
                            to={item.path}
                            onClick={onNavigate}
                          >
                            <Icon name={item.icon} />
                            <span className='side-bar__label'>
                              {item.label}
                            </span>
                          </NavLink>
                        )}
                        {item.children && isOpen && (
                          <ul className='side-bar__leaf-list'>
                            {item.children.map((child) => (
                              <li key={child.label}>
                                <NavLink
                                  className='side-bar__link side-bar__link--leaf'
                                  to={child.path}
                                  onClick={onNavigate}
                                >
                                  <Icon name={child.icon} />
                                  <span className='side-bar__label'>
                                    {child.label}
                                  </span>
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    )
                  })}
                </ul>
              )}
            </li>
          )}
        </ul>
      </nav>
    </aside>
  )
}

export default SideBar
